const nativeDatePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
const displayedDatePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export const toDateInputValue = (value) => {
  const date = String(value || "");
  if (nativeDatePattern.test(date)) return date;

  const displayed = date.match(displayedDatePattern);
  return displayed ? `${displayed[3]}-${displayed[2]}-${displayed[1]}` : "";
};

export const formatEnrollmentDate = (value) => {
  const date = String(value || "");
  const native = date.match(nativeDatePattern);
  return native ? `${native[3]}/${native[2]}/${native[1]}` : date;
};
